import { cardActionsClasses, cardClasses, cardContentClasses, cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "core/themes/src/definitions/components.types"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        root: {
            [`.${cardClasses.root}`]: {
                "&:hover": {
                    borderColor: "#007df6",
                },
            },
        },
    },
    variants: [
        {
            props: { widgetVariant: "startpage" },
            style: {
                [`.${cardClasses.root}`]: {
                    boxShadow: "0 1px 5px 0 rgba(0,0,0,.13)",
                    [`.${cardHeaderClasses.root}`]: {
                        padding: "1em 1em 0px",
                    },
                    [`.${cardContentClasses.root}`]: {
                        padding: "1em",
                    },
                },
            },
        },
        {
            props: { widgetVariant: "dashboard" },
            style: {
                padding: ".5em .75em",
                [`.${cardClasses.root}`]: {
                    [`.${cardHeaderClasses.root}`]: {
                        [`.${cardHeaderClasses.content}`]: {
                            [`.${typographyClasses.root}`]: {
                                fontSize: "1.5rem",
                            },
                        },
                    },
                    [`.${cardActionsClasses.root}`]: {
                        padding: "0 1em 1em",
                    },
                },
            },
        },
    ],
})
